import { rgba } from 'polished';
import styled from 'styled-components';

interface SeatProps {
  selected: boolean;
  color: string;
  activeColor: string;
  fade: boolean;
}

export default {
  Wrapper: styled.div<any>`
    position: relative;
    padding: ${(props) => `48px 24px ${props.offset + 56}px`};
    background-color: ${({ theme }) => theme.backgroundColor || '#f5f5f5'};
    border-top: 1px solid #e1e1e1;
  `,
  RowsTable: styled.table`
    border-spacing: 0 16px;
  `,
  Row: styled.tr`
    @media screen and (max-width: 700px) {
      display: flex;
      flex-direction: column;
    }
  `,
  RowLabel: styled.div`
    white-space: nowrap;
    margin-right: 8px;
  `,
  Seats: styled.div`
    > div {
      display: inline-block;
    }
  `,
  Seat: styled.div<SeatProps>`
    text-align: center;
    cursor: pointer;
    width: 32px;
    height: 32px;
    border: ${(props) => `1px solid ${props.color}`};
    border-radius: 8px;
    margin-right: 2px;
    margin-bottom: 2px;
    line-height: 32px;
    background-color: #fff;

    &:hover {
      background-color: ${(props) => `${rgba(props.color, 0.24)}`};
    }

    ${(props) =>
      props.selected &&
      `
      background-color: ${props.activeColor};
      border-color: ${props.activeColor};
      color: #fff;

      &:hover {
        background-color: ${props.activeColor};
      }
    `}

    ${(props) =>
      props.fade &&
      `
        opacity: 0.3;
    `}
  `,

  Back: styled.div`
    position: absolute;
    top: 0;
    left: 19px;
  `,

  SectorName: styled.div`
    position: absolute;
    top: 7px;
    right: 24px;
    font-size: 14px;
    line-height: 18px;
  `,
};
